export default "__VITE_ASSET__C62pGfcJ__"